import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox, FlatColorPicker, TextBox } from "@progress/kendo-react-inputs";
import { Dialog, Window } from "@progress/kendo-react-dialogs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { copyIcon, plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";
import { Offset, Popup } from "@progress/kendo-react-popup";

export const RegistryGroups = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const COLORS = {
        primary: '#018CA5',
        accent: '#198793',
        selectedBg: '#198792',
        panelBg: '#F7F7F7',
        title: '#1A8893',
        white: '#ffffff',
        markerRed: '#FF0000'
    };

    const userType = localStorage.getItem('userType');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');

    const [valueColor, setValueColor] = useState<any>('#ffffff');
    const [groupsList, setGroupsList] = useState<any>([]);
    const [groupSearchValue, setGroupSearchValue] = useState<string>('');
    const [jobsList, setJobsList] = useState<any>([]);
    const [jobsLoaded, setJobsLoaded] = useState<boolean>(false);

    const [toggleColorPicker, setToggleColorPicker] = useState<boolean>(false);

    const [groupInfo, setGroupInfo] = useState<any>([{ 'id': '', 'name': '', 'description': '', 'color': '', 'job': '', 'type': '' }]);


    const [groupName, setGroupName] = useState<any>('');
    const [groupDescription, setGroupDescription] = useState<any>('');
    const [groupTypeName, setGroupTypeName] = useState<any>('');
    const [groupTypeId, setGroupTypeId] = useState<any>('');

    const [jobsSelected, setJobsSelected] = useState<any>([]);

    const [updateGroup, setUpdateGroup] = useState<boolean>(false);
    const [selectedGroupId, setSelectedGroupId] = useState<any>(null);

    const [messageDeletedGroup, setMessageDeletedGroup] = useState<boolean>(false);
    const [messageSavedGroup, setMessageSavedGroup] = useState<boolean>(false);
    const [messageClonedGroup, setMessageClonedGroup] = useState<boolean>(false);
    const [messageUpdatedGroup, setMessageUpdatedGroup] = useState<boolean>(false);

    const groupsTypeList = {
        "data": [
            {
                "id": 0,
                "name": 'Generic'
            },
            {
                "id": 1,
                "name": 'Pointer'
            },
            {
                "id": 2,
                "name": 'Forklift'
            },
            {
                "id": 3,
                "name": 'Truck'
            },
            {
                "id": 4,
                "name": 'Car'
            },
            {
                "id": 5,
                "name": 'Man'
            },
            {
                "id": 6,
                "name": 'Named'
            }
        ]
    }

    useEffect(() => {
        getGroupList(true, true);
        getJobList(true);
    }, []);

    const hasAppliedDefaultSelectionRef = useRef(false);

    useEffect(() => {
        if (hasAppliedDefaultSelectionRef.current) {
            return;
        }

        if (!jobsLoaded) {
            return;
        }

        if (selectedGroupId !== null) {
            hasAppliedDefaultSelectionRef.current = true;
            return;
        }

        if (!Array.isArray(groupsList) || groupsList.length === 0) {
            return;
        }

        hasAppliedDefaultSelectionRef.current = true;
        getSelectedGroup(groupsList[0]);
    }, [groupsList, jobsLoaded, selectedGroupId]);

    const getGroupList = async (flag: boolean, needsJobs: boolean) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/list?enabled=${flag}&needsJobs=${needsJobs}`, { headers })
                .then((res) => {
                    const data = res?.data?.data
                    setGroupsList(data);

                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setLoading(false);
                });
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
    }

    const getJobList = async (flag: boolean) => {

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/job/list?enabled=${flag}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let jobList: any = []
                    data.forEach((job: any) => {
                        jobList.push(job)
                    });
                    setJobsList(jobList);
                    setJobsLoaded(true);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setJobsLoaded(true);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setJobsLoaded(true);
                });
            setLoading(false);
        }
    };

    const rgba2hex = (rgba: any) => {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
            .split(',') // splits them at ","
            .filter((string: any, index: any) => index !== 3)
            .map((string: any) => parseFloat(string)) // Converts them to numbers
            .map((number: any, index: any) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
            .map((number: any) => number.toString(16)) // Converts numbers to hex
            .map((string: any) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
            .join("")
    }

    const handleChangeColor = useCallback((event: any) => {
        let color: any = rgba2hex(event.value);
        setValueColor(color);
        setToggleColorPicker(false)
    }, []);

    const showColorPicker = () => {
        setToggleColorPicker(!toggleColorPicker);
    }

    const handleChangeGroupName = (event: any) => {
        let currentName: any = event.target.value
        setGroupName(currentName)

        if (currentName == '') {
            setGroupName([]);
        } else {
            let newGroup: any = [];
            newGroup.push({ 'id': groupInfo[0]?.id, 'name': currentName, 'description': groupInfo[0]?.description, 'color': groupInfo[0]?.color, 'job': groupInfo[0]?.job, 'type': groupInfo[0]?.type })
            setGroupInfo(newGroup);
        }
    }

    const handleChangeGroupDescription = (event: any) => {
        let currentDescription: any = event.target.value
        setGroupDescription(currentDescription)
        let newGroup: any = [];
        if (currentDescription == '') {
            setGroupDescription([]);
            newGroup.push({ 'id': groupInfo[0].id, 'name': groupInfo[0].name, 'description': currentDescription, 'color': groupInfo[0].color, 'job': groupInfo[0].job, 'type': groupInfo[0].type })
            setGroupInfo(newGroup);
        } else {
            newGroup.push({ 'id': groupInfo[0].id, 'name': groupInfo[0].name, 'description': currentDescription, 'color': groupInfo[0].color, 'job': groupInfo[0].job, 'type': groupInfo[0].type })
            setGroupInfo(newGroup);
        }
    }

    const handleChangeJob = (ev: any, jobId: any) => {

        let currentJobs: any = (groupInfo[0]?.job != "" && groupInfo[0]?.job != undefined) ? groupInfo[0]?.job : []

        let checked: any = ev?.target?.element?.checked ?? ev;

        jobsList?.forEach((job: any) => {
            if (jobId === job.id) {
                job.checked = checked;

                if (checked) {
                    currentJobs?.push(job);
                } else {
                    const removeIdx = currentJobs?.findIndex((j: any) => j.id === job.id);
                    if (removeIdx !== -1) {
                        currentJobs?.splice(removeIdx, 1);
                    }
                }
            }
        });

        setJobsSelected([...currentJobs]);


        let newGroup: any = [];
        newGroup.push({ 'id': groupInfo[0]?.id, 'name': groupInfo[0]?.name, 'description': groupInfo[0]?.description, 'color': groupInfo[0]?.color, 'job': currentJobs, 'type': groupInfo[0]?.type })
        setGroupInfo(newGroup);

    }

    const handleChangeGroupType = (event: any) => {
        setGroupTypeName(event.target.value);
        //setGroupTypeId(event.target.index);

        const groupSelected: any = groupsTypeList.data.find((group: any) => group.name == event.target.value);
        setGroupTypeId(groupSelected.id);
        let newGroup: any = [];
        newGroup.push({ 'id': groupInfo[0]?.id, 'name': groupInfo[0]?.name, 'description': groupInfo[0]?.description, 'color': groupInfo[0]?.color, 'job': groupInfo[0]?.job, 'type': groupSelected?.id })
        //newGroup.push({ 'id': groupSelected?.id, 'name': groupSelected?.name, 'description': groupSelected?.description, 'color': groupSelected?.color, 'job': groupSelected?.job, 'type': groupSelected?.id })
        setGroupInfo(newGroup);
    }

    const capitalizeFirstLetter = (str: any) => {
        if (typeof str !== 'string' || str.length === 0) {
            return ''; // Gestisce stringhe vuote o non stringhe
        }
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    const getSelectedGroup = (group: any) => {

        if (!group) {
            return;
        }

        //getGroupList(true, true);
        setSelectedGroupId(group.id);

        const groupType = capitalizeFirstLetter(group.groupType);

        setGroupInfo([{ 'id': group.id, 'name': group.name, 'description': group.description, 'color': group.color, 'job': group.jobs, 'type': groupType }]);

        setGroupName(group.name)
        setGroupDescription(group.description)
        setValueColor(group.color);
        setGroupTypeName(groupType);

        const selectedJobIds = new Set(
            Array.isArray(group?.jobs) ? group.jobs.map((job: any) => job?.id) : []
        );

        const normalizedJobs = (Array.isArray(jobsList) ? jobsList : []).map((item: any) => ({
            ...item,
            checked: selectedJobIds.has(item?.id)
        }));

        setJobsList(normalizedJobs);
        setJobsSelected(normalizedJobs.filter((item: any) => item?.checked));

        setUpdateGroup(true)
    }

    const updateSelectedGroup = async (groupId: any, groupName: any, groupDescription: any, groupColor: any, jobList: any, groupType: any) => {

        setLoading(true);

        let jobListId: any = []
        jobList?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: groupName,
                description: groupDescription,
                color: groupColor,
                type: groupType,
                jobList: jobListId
            }
            try {
                await axios.put(`${SERVER_URL}/group/${groupId}`, params, { headers })

                setMessageUpdatedGroup(true);
                if (!messageUpdatedGroup) {
                    setTimeout(() => {
                        setMessageUpdatedGroup(false);
                    }, 3000);
                }

                getGroupList(true, true);

            } catch (error: any) {
                getGroupList(true, true);
                if (error.code == 'ERR_BAD_RESPONSE') {
                    //setErrorMessage(error?.response?.data?.errorMessage)
                    setError(true);
                    if (error) {
                        setTimeout(() => {
                            //setErrorMessage('');
                            setError(false);
                        }, 3000);
                    }
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }


    }

    const saveNewGroup = async (currGroupName: any, currValueColor: any) => {

        setLoading(true);

        let jobListId: any = []
        jobsSelected?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        let currGroup: any = [{ 'name': currGroupName[0].name, 'description': currGroupName[0].description, 'color': currValueColor, 'job': jobsSelected, 'groupType': groupTypeId }];

        if (groupsList.length > 0 || currGroupName.length != 0) {
            if (groupsList.some((e: any) => e.name === currGroupName[0].name) || currGroupName[0].name == '' || currGroupName.length == 0) {

            } else {
                setGroupsList([...groupsList, currGroup[0]]);
            }

        } else {
            setGroupsList([...groupsList, currGroupName]);
            return;
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currGroup[0]?.name,
                color: currGroup[0]?.color ?? '#ffffff',
                description: currGroup[0]?.description ?? '',
                groupType: groupTypeId != '' ? groupTypeId : 0,
                jobs: jobListId
            };
            try {
                await axios.post(`${SERVER_URL}/group`, params, { headers })
                setGroupName('')
                handleChangeGroupName({ target: { value: '' } })
                setGroupDescription('')
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                jobsList.forEach((job: any) => {
                    job.checked = false
                })
                setJobsSelected([])
                setGroupTypeName('')

                setMessageSavedGroup(true);
                if (!messageSavedGroup) {
                    setTimeout(() => {
                        setMessageSavedGroup(false);
                    }, 3000);
                }

                getGroupList(true, true);

            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const cloneGroup = async (groupInfo: any) => {

        setLoading(true);

        let jobListId: any = []
        jobsSelected?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        let currGroup: any = [{ 'name': groupInfo.name, 'description': groupInfo.description, 'color': groupInfo.color, 'job': jobsSelected, 'groupType': groupInfo.groupType }];

        if (groupsList.length > 0 || groupInfo.name.length != 0) {
            if (groupsList.some((e: any) => e.name === groupInfo.name) || groupInfo.name == '' || groupInfo.name.length == 0) {

            } else {
                setGroupsList([...groupsList, currGroup[0]]);
            }

        } else {
            setGroupsList([...groupsList, groupInfo.name]);
            return;
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                await axios.post(`${SERVER_URL}/group/${groupInfo.id}/copy`, null, { headers })
                setGroupName('')
                handleChangeGroupName({ target: { value: '' } })
                setGroupDescription('')
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '' })
                jobsList?.forEach((job: any) => {
                    job.checked = false
                })
                setJobsSelected([])
                getGroupList(true, true);
                setMessageClonedGroup(true);
                if (!messageClonedGroup) {
                    setTimeout(() => {
                        setMessageClonedGroup(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 5000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

    }

    const removeNewGroup = async (groupId: any, index: any) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/group/${groupId}`, { headers }),
                    setGroupsList((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })
                handleChangeGroupName({ target: { value: '' } })
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)
                setMessageDeletedGroup(true)
            } catch (error: any) {
                setError(true);
                if (!error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageDeletedGroup || !error) {
            setTimeout(() => {
                setMessageDeletedGroup(false);
                setError(false);
            }, 3000);
        }
    }

    const refreshGroup = () => {
        setGroupName('')
        handleChangeGroupName({ target: { value: '' } })
        setGroupDescription('')
        handleChangeGroupDescription({ target: { value: '' } })
        jobsList.forEach((job: any) => {
            job.checked = false
        })
        setJobsSelected([])
        setGroupTypeName('')
        setUpdateGroup(false)
        setSelectedGroupId(null)
        handleChangeColor({ value: '#ffffff' })
        setValueColor('#ffffff')
    }

    const bolderStyles = `

        .registry-group-root {
            gap: 12px;
            align-items: stretch;
            padding: 10px;
        }
            
        .registry-group-left-panel {
            border: 1px solid #d6e8ee;
            border-radius: 14px;
            box-shadow: 0 10px 24px rgba(10, 55, 75, 0.08);
        }

        .registry-group-title {
            font-weight: 800;
            letter-spacing: 0.4px;
            text-shadow: 0 1px 0 rgba(255, 255, 255, 0.7);
        }

        .registry-group-item {
            background: #ffffff;
            border: 1px solid #cfe3ea;
            border-radius: 12px;
            padding: 6px 8px;
            box-shadow: 0 3px 10px rgba(10, 55, 75, 0.06);
            transition: transform 120ms ease, box-shadow 180ms ease;
        }

        .registry-group-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(10, 55, 75, 0.12);
        }

        .registry-group-form-row {
            display: flex;
            margin-bottom: 20px;
            align-items: center;
        }

        .registry-group-label {
            width: 180px;
            align-content: center;
            font-weight: 700;
            color: #0f5f69;
            letter-spacing: 0.2px;
        }

        .registry-group-right {
            border: 1px solid #cfe3ea;
            border-radius: 16px;
            box-shadow: 0 14px 30px rgba(10, 55, 75, 0.1);
            padding: 14px 16px;
        }
    `;

    const normalizedGroupSearchValue = groupSearchValue.trim().toLowerCase();
    const filteredGroupsList = normalizedGroupSearchValue
        ? groupsList.filter((group: any) => {
            const groupName = `${group?.name ?? ''}`.toLowerCase();
            const groupDescription = `${group?.description ?? ''}`.toLowerCase();
            const groupType = `${group?.groupType ?? ''}`.toLowerCase();
            const groupId = `${group?.id ?? ''}`.toLowerCase();

            return groupName.includes(normalizedGroupSearchValue)
                || groupDescription.includes(normalizedGroupSearchValue)
                || groupType.includes(normalizedGroupSearchValue)
                || groupId.includes(normalizedGroupSearchValue);
        })
        : groupsList;

    return (
        <div className="flex-parent-element registry-group-root" style={{ overflowX: 'hidden' }}>

            <style>{bolderStyles}</style>

            {loading && loadingPanel}

            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 0,
                    position: "absolute",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {messageDeletedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageDeletedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_deleted', 'NOT_FOUND')}</span>
                        </Notification>
                    )}
                    {messageSavedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageSavedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_saved', 'NOT_FOUND')}</span>
                        </Notification>
                    )}
                    {messageClonedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageClonedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_cloned', 'NOT_FOUND')}</span>
                        </Notification>
                    )}
                    {messageUpdatedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageUpdatedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_updated', 'NOT_FOUND')}</span>
                        </Notification>
                    )}
                    {error && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            //closable={true}
                            onClose={() => {
                                setError(false)
                            }}
                        ><span>{localizationService.toLanguageString('configuration.registry.group_with_device_error', 'NOT_FOUND')}</span>
                            {/*{
                                errorMessage != ''
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.registry.group_with_device_error', 'NOT_FOUND')}</span>
                            }*/}
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            {/*left panel*/}
            <div
                className="registry-group-left-panel"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    background: '#F7F7F7',
                    flex: '1.5 1 0px',
                    overflowY: 'hidden',
                }}
            >
                <div style={{ textAlign: 'center', marginBottom: '10px', justifyContent: 'space-between' }}>

                    <p className="registry-group-title" style={{ display: 'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}>
                        {localizationService.toLanguageString('configuration.registry.groups', 'NOT_FOUND')} ({filteredGroupsList.length})
                    </p>

                    <Button
                        title={localizationService.toLanguageString('configuration.registry.group_new', 'NOT_FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                            borderRadius: '10px',
                            //boxShadow: '0 3px 10px rgba(26,136,147,0.28)'
                        }}
                        onClick={refreshGroup}
                        disabled={userType === 'StandardOnlyLocator'}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <TextBox
                    value={groupSearchValue}
                    onChange={(event: any) => setGroupSearchValue(`${event.target.value ?? ''}`)}
                    placeholder={localizationService.toLanguageString('configuration.registry.group_search_placeholder', 'Search group')}
                    style={{ width: '100%', marginBottom: '10px' }}
                />

                <div
                    className="flex-left-child-element"
                    style={{
                        flex: 1,
                        minHeight: 0,
                        padding: '8px',
                        overflowY: 'auto',
                        width: '100%',
                    }}
                >
                    {filteredGroupsList?.map((group: any, index: any) => {
                        const originalIndex = groupsList.findIndex((item: any) => item?.id === group?.id);
                        const indexToRemove = originalIndex !== -1 ? originalIndex : index;

                        return (
                            group.id != -1 &&
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '6px'
                                }}
                            >

                                <div
                                    className="trash-icon"
                                    title={localizationService.toLanguageString('configuration.registry.group_delete', 'NOT_FOUND')}
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        setUpdateGroup(false)
                                        removeNewGroup(group.id, indexToRemove)
                                    }}
                                >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon
                                            icon={trashIcon}
                                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                                        />
                                    </Avatar>
                                </div>

                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        setUpdateGroup(false)
                                        cloneGroup(group)
                                    }}
                                    title={localizationService.toLanguageString('configuration.registry.group_clone', 'NOT_FOUND')}
                                >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon
                                            icon={copyIcon}
                                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                                        />
                                    </Avatar>
                                </div>

                                <div
                                    style={{ display: 'inline-flex', alignItems: 'center', flex: 1 }}
                                >
                                    <p
                                        style={{
                                            border: `1px solid ${(group?.color == '#ffffff' || group?.color == '#NaN') ? 'black' : group?.color}`,
                                            borderRadius: '30px',
                                            width: '18px',
                                            height: '18px',
                                            marginTop: '10px',
                                            background: `${group?.color}`
                                        }}
                                    ></p>
                                    <p
                                        className="card-block-registry-group registry-group-item"
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            marginBottom: '0px',
                                            padding: '10px',
                                            flex: 1,
                                            color: selectedGroupId === group.id ? '#ffffff' : 'inherit',
                                            background: selectedGroupId === group.id ? '#198792' : '#ffffff',
                                            fontSize: 'clamp(11px, 0.7vw, 16px)'
                                        }}
                                        onClick={() => getSelectedGroup(group)}
                                    >
                                        {`${group?.id ?? ''}: ${group?.name}`}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>


            {/*right panel*/}
            <div
                className="flex-right-child-element registry-group-right"
                style={{
                    background: COLORS.white,
                }}
            >

                <div>
                    <div className="registry-group-form-row">
                        {/*name*/}
                        <div className="registry-group-label">
                            {localizationService.toLanguageString('configuration.registry.group_name', 'NOT_FOUND')}
                        </div>

                        <div style={{ display: 'flex', width: '350px' }}>
                            <TextBox
                                style={{ width: "350px", marginRight: '10px' }}
                                value={groupName == '' ? groupName : groupInfo?.map((group: any) => {
                                    return group.name
                                })}
                                onChange={handleChangeGroupName}
                                placeholder=''
                                disabled={userType === 'StandardOnlyLocator'}
                            />

                            {/*save / update*/}
                            {!updateGroup ?
                                <Button
                                    title={localizationService.toLanguageString('configuration.registry.group_save', 'NOT_FOUND')}
                                    themeColor={"primary"}
                                    className="saveParam"
                                    disabled={groupName == '' ? true : false || userType === 'StandardOnlyLocator'}
                                    onClick={() => saveNewGroup(groupInfo, valueColor)}
                                >
                                    <Avatar
                                        className="saveParam"
                                    >
                                        <SvgIcon
                                            icon={saveIcon}
                                            style={{ margin: '8px' }}
                                        />
                                    </Avatar>
                                </Button>
                                :
                                <div>
                                    <Button
                                        title={localizationService.toLanguageString('configuration.registry.group_update', 'NOT_FOUND')}
                                        themeColor={"primary"}
                                        className="saveParam"
                                        disabled={userType === 'StandardOnlyLocator'}
                                        onClick={() => updateSelectedGroup(groupInfo[0].id, groupInfo[0].name, groupInfo[0].description, valueColor == groupInfo[0].color ? groupInfo[0].color : valueColor, groupInfo[0].job, groupInfo[0].type)}
                                    >
                                        <Avatar
                                            className="saveParam"
                                        >
                                            <SvgIcon
                                                icon={saveIcon}
                                                style={{ margin: '8px' }}
                                            />
                                        </Avatar>
                                    </Button>
                                </div>
                            }
                        </div>

                    </div>

                    {/*description*/}
                    <div className="registry-group-form-row">
                        <div className="registry-group-label">
                            {localizationService.toLanguageString('configuration.registry.group_description', 'NOT_FOUND')}
                        </div>
                        <TextBox
                            style={{ width: "350px" }}
                            value={groupDescription == "" ? groupDescription : groupInfo?.map((group: any) => {
                                return group.description
                            })}
                            onChange={handleChangeGroupDescription}
                            placeholder=''
                            disabled={userType === 'StandardOnlyLocator'}
                        />
                    </div>

                    {/*group type*/}
                    <div className="registry-group-form-row">
                        <div className="registry-group-label">
                            {localizationService.toLanguageString('configuration.registry.subscription_group_type', 'NOT_FOUND')}
                        </div>
                        <DropDownList
                            style={{
                                width: "350px",
                                marginRight: '15px'
                            }}
                            data={groupsTypeList?.data.map((group: any) => {
                                return (
                                    group.name
                                )
                            })}
                            value={groupTypeName != '' ? groupTypeName : groupsTypeList.data[0].name}
                            onChange={handleChangeGroupType}
                            disabled={userType === 'StandardOnlyLocator'}
                        />
                    </div>

                    {/*colorpicker*/}
                    <div className="registry-group-form-row">
                        <div className="registry-group-label">
                            {localizationService.toLanguageString('configuration.registry.group_color', 'NOT_FOUND')}
                        </div>
                        <span
                            className="k-icon k-font-icon k-i-palette"
                            style={{
                                width: '0px',
                                height: '0px',
                                fontSize: 'x-large',
                                cursor: 'pointer',
                                background: `${valueColor}`,
                                border: '1px solid #bdc4cb',
                                borderRadius: '30px',
                                padding: '20px',
                                marginRight: '0px 10px 0px 85px',
                                pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                            }}
                            onClick={showColorPicker}
                        />
                        {
                            toggleColorPicker && (
                                <Dialog
                                    className="no-padding-dialog"
                                    onClose={() => setToggleColorPicker(false)}
                                >
                                    <FlatColorPicker
                                        value={valueColor}
                                        format="hex"
                                        onChange={handleChangeColor}
                                    />
                                </Dialog>
                            )}
                    </div>

                    {/*assignable jobs*/}
                    {jobsList.length > 0 &&
                        <div className="registry-group-form-row">
                            {/*jobsList*/}
                            <div className="registry-group-label">
                                {localizationService.toLanguageString('configuration.registry.group_assignable_jobs', 'NOT_FOUND')}
                            </div>
                            <div style={{ width: '60%', maxHeight: '85%', overflowY: 'auto' }}>
                                {jobsList?.map((job: any, index: any) => {
                                    return (
                                        job.id != -1 &&
                                        <Checkbox
                                            key={index}
                                            name={job?.name}
                                            style={{ marginLeft: '15px' }}
                                            value={job?.name ?? job}
                                            checked={job?.checked}
                                            onChange={(e: any) => handleChangeJob(e, job.id)}
                                            label={job?.name ?? ''}
                                            disabled={userType === 'StandardOnlyLocator'}
                                        >
                                            <label className="checkbox-label-beacon" style={{ background: job?.color }} />
                                        </Checkbox>
                                    );
                                })}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );


};
